import { render } from "./TravelPassBuyerDetails.vue?vue&type=template&id=40759c8b&lang=pug"
import script from "./TravelPassBuyerDetails.vue?vue&type=script&lang=ts"
export * from "./TravelPassBuyerDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script